export function safeParseDate(value) {
    if (value === null || value === undefined) {
        return null;
    }
    return parseDateOrThrow(value);
}
export function parseDateOrThrow(input) {
    const result = new Date(input);
    if (Number.isNaN(result.getTime())) {
        throw new Error(`Invalid input for date parsing: '${input}'`);
    }
    return result;
}
//# sourceMappingURL=date.js.map